import styled from 'styled-components'

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 70vh;
`

export const ContentWrapper = styled.div`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor20};
`
